import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router";
import { MakeSlot, ProductSticker } from "../components/ProductSticker.tsx";
import { useConfig } from "../components/Shell.tsx";
import { api, call } from "../lib/api.ts";

const LABELS: Record<string, string> = {
  apparel: "Tees & tops",
  home: "Home",
  wall: "Wall art",
  accessories: "Accessories",
};

export function ShopPage() {
  const [params, setParams] = useSearchParams();
  const category = params.get("c") ?? "";
  const cfg = useConfig();
  const all = useQuery({
    queryKey: ["products"],
    queryFn: () => call(api.products.$get({ query: {} })),
  });
  const list = (all.data?.products ?? []).filter((p) => !category || p.category === category);
  const categories = [...new Set((all.data?.products ?? []).map((p) => p.category))];

  return (
    <div className="sheet">
      <header className="pagehead">
        <h1 className="page-title">The whole sheet</h1>
        <p className="lede">Ready-made memes, printed when you order. Don't see yours? Make it.</p>
        {categories.length > 1 && (
          <div className="chips filterchips" role="group" aria-label="Filter by category">
            <button
              type="button"
              className="chip"
              aria-pressed={!category}
              onClick={() => setParams({})}
            >
              Everything
            </button>
            {categories.map((c) => (
              <button
                key={c}
                type="button"
                className="chip"
                aria-pressed={category === c}
                onClick={() => setParams({ c })}
              >
                {LABELS[c] ?? c}
              </button>
            ))}
          </div>
        )}
      </header>
      {all.isError ? (
        <div className="notice" data-tone="error">
          We couldn't load the shop.{" "}
          <button type="button" className="link-btn" onClick={() => all.refetch()}>
            Try again
          </button>
        </div>
      ) : (
        <div className="sheetgrid">
          {all.isLoading
            ? [0, 1, 2, 3].map((i) => <div key={i} className="skeleton sheetgrid__skeleton" />)
            : list.map((p, i) => (
                <ProductSticker
                  key={p.id}
                  product={p}
                  index={i}
                  currency={cfg.data?.currency ?? "EUR"}
                />
              ))}
          <MakeSlot />
        </div>
      )}
    </div>
  );
}
